<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-wrap pb-4 justify-start">
    <h1 class="headeradminui-text pl-2">Manage Therapy Plans Subscription</h1>
  </div>
  <div
    class="flex items-start gap-4"
    style="background: #ececec; padding: 30px"
  >
    <nz-card
      [nzLoading]="pageLoading"
      *ngIf="tableData.userDetails"
      style="width: 400px"
      [nzBordered]="false"
      nzTitle="User info"
    >
      <p>User Name : {{ tableData.userDetails.name }}</p>
      <p>User Email : {{ tableData.userDetails.email }}</p>
      <p>Gender: {{ tableData.userDetails.gender }}</p>
      <p>phone: {{ tableData.userDetails.phone }}</p>
      <p>partnerId: {{ tableData.userDetails.partnerId }}</p>
      <div class="flex gap-1 flex-wrap">
        tags:
        <nz-tag
          *ngFor="let tag of tableData.userDetails.userTags"
          [nzColor]="color"
          >{{ tag }}</nz-tag
        >
      </div>
    </nz-card>
    <nz-card
      id="top-container"
      class="animate-bounce-custom w-full"
      *ngIf="selectedSubscription"
      [nzBordered]="false"
      nzTitle="Therapist for Selected sessions"
      [nzExtra]="extraTemplate"
    >
      <p>Therapist Name : {{ therapistName }}</p>
      <p>Therapist Email : {{ therapistEmail }}</p>
    </nz-card>
    <ng-template #extraTemplate>
      <button *ngIf="showAddExtraSessionBtn" nz-button (click)="showModal()">
        Add Extra Sessions
      </button>
    </ng-template>
  </div>
  <div class="flex flex-wrap items-center gap-4 p-1">
    <nz-range-picker
      nzSize="large"
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="dateRange"
      (ngModelChange)="dateChange($event)"
    ></nz-range-picker>
    <nz-input-group
      nzSearch
      nzSize="large"
      class="w-[360px]"
      [nzAddOnAfter]="globalSearchButton"
    >
      <input
        type="text"
        nz-input
        [(ngModel)]="globalSearchInput"
        (keyup.enter)="searchGlobal()"
        placeholder="Search by subscription id or plan name"
      />
    </nz-input-group>
    <ng-template #globalSearchButton>
      <button
        nz-button
        nzType="primary"
        nzSize="small"
        nzSearch
        (click)="searchGlobal()"
      >
        Search
      </button>
    </ng-template>
  </div>
  <nz-spin [nzSpinning]="pageLoading">
    <nz-tabset (nzSelectChange)="tabChange($event)">
      <nz-tab nzTitle="Active">
        <app-plan-subscription-table
          #activeTableComponent
          [inputTableData]="tableData"
          [showBlockButton]="true"
          (resetFilterEvent)="resetFilter()"
          (pageChangeEvent)="nzPageIndexChange($event)"
          (pageSizeChangeEvent)="nzPageSizeChange($event)"
          (reloadEvent)="fetchTherapyPlans()"
          (exportDataEvent)="exportDataFn()"
          (scrollEvent)="scrollToTop()"
          (showTransferModal)="showModalTransfer($event)"
          [showSendFeedbackButton]="showSendFeedbackBtn"
          (showSendFeedbackModal)="showModalSendFeedback($event)"
          (selectedItem)="setSelectedItem($event)"
          (therapistEmailEvent)="setTherapistEmail($event)"
          (therapistNameEvent)="setTherapistName($event)"
          (searchByPlanNameEvent)="searchByPlanName($event)"
          (purchasedAtFilterDateChangeEvent)="
            purchasedAtFilterDateChange($event)
          "
          (validTillFilterDateChangeEvent)="validTillFilterDateChange($event)"
          (tagsFilterChangeEvent)="tagsFilterChangeFn($event)"
          (onBlockSubscriptionEvent)="onBlockSubscription($event)"
          (openBlockMessageModalEvent)="openBlockMessageModal($event)"
        ></app-plan-subscription-table>
      </nz-tab>
      <nz-tab nzTitle="Inactive/Completed">
        <app-plan-subscription-table
          #inActiveTableComponent
          [inputTableData]="tableData"
          (exportDataEvent)="exportDataFn()"
          (resetFilterEvent)="resetFilter()"
          (pageChangeEvent)="nzPageIndexChange($event)"
          (pageSizeChangeEvent)="nzPageSizeChange($event)"
          (reloadEvent)="fetchTherapyPlans()"
          (exportDataEvent)="exportDataFn()"
          (scrollEvent)="scrollToTop()"
          (showTransferModal)="showModalTransfer($event)"
          [showSendFeedbackButton]="showSendFeedbackBtn"
          (showSendFeedbackModal)="showModalSendFeedback($event)"
          (selectedItem)="setSelectedItem($event)"
          (therapistEmailEvent)="setTherapistEmail($event)"
          (therapistNameEvent)="setTherapistName($event)"
          (searchByPlanNameEvent)="searchByPlanName($event)"
          (purchasedAtFilterDateChangeEvent)="
            purchasedAtFilterDateChange($event)
          "
          (validTillFilterDateChangeEvent)="validTillFilterDateChange($event)"
          (tagsFilterChangeEvent)="tagsFilterChangeFn($event)"
          (onBlockSubscriptionEvent)="onBlockSubscription($event)"
          (openBlockMessageModalEvent)="openBlockMessageModal($event)"
        ></app-plan-subscription-table>
      </nz-tab>
    </nz-tabset>
  </nz-spin>
</div>
<nz-modal
  [nzOkLoading]="pageLoading"
  [(nzVisible)]="isVisible"
  nzTitle="Add Extra Sessions"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <label>Session Name</label>
    <input
      nz-input
      placeholder="session name"
      [(ngModel)]="extraSessionName"
      type="text"
    />
    <label>Session Description</label>
    <textarea
      class="mt-1"
      rows="3"
      placeholder="Description"
      nz-input
      [(ngModel)]="extraSessionDescription"
    ></textarea>
  </ng-container>
</nz-modal>
<nz-modal
  [(nzVisible)]="isVisibleTransfer"
  [nzOkLoading]="transferTherapistLoading"
  [nzOkDisabled]="
    !selectedTherapistId ||
    (transferConfirmedSessions &&
      affectedSessions.length > 0 &&
      sessionOkDisabled)
  "
  nzTitle="Select New Therapist To Transfer"
  (nzOnCancel)="handleCancelTransfer()"
  (nzOnOk)="handleTransferTherapist()"
>
  <ng-container *nzModalContent>
    <nz-select
      class="w-full"
      nzShowSearch
      nzAllowClear
      nzPlaceHolder="Select a therapists"
      [(ngModel)]="selectedTherapistId"
      (ngModelChange)="onNewTherapistSelected($event)"
    >
      <nz-option
        *ngFor="let therapist of therapistDropdownData"
        [nzValue]="therapist.value"
        [nzLabel]="therapist.label"
      ></nz-option>
    </nz-select>

    <div class="mt-4" *ngIf="affectedSessions.length > 0">
      <label
        nz-checkbox
        [(ngModel)]="transferConfirmedSessions"
        (ngModelChange)="onTransferConfirmedToggle($event)"
      >
        Also transfer confirmed upcoming sessions
      </label>
    </div>

    <app-session-feedback-selector
      *ngIf="isVisibleTransfer && selectedSubscription"
      [sessions]="selectedSubscription.sessionDetailslist"
      title="Send a feedback document mail to the new therapist"
      (selectedSessionIdsChange)="feedbackSessionIds = $event"
    ></app-session-feedback-selector>

    <div
      *ngIf="transferConfirmedSessions"
      class="mt-3 p-3"
      style="background: #f7f7f7; border-radius: 6px"
    >
      <p>
        <strong>Sessions to be reassigned:</strong>
        {{ affectedSessions.length }}
      </p>
      <ul>
        <li *ngFor="let s of affectedSessions">
          {{ s.sessionName || "Session" }} — {{ formatDateTime(s.sessionDate) }}
        </li>
      </ul>
      <p class="mt-2"><strong>Notifications will be sent to:</strong></p>
      <ul>
        <li>Client: {{ selectedSubscription?.userDetails?.email || "N/A" }}</li>
        <li>
          Original therapist(s):
          <span *ngFor="let s of affectedSessions; let i = index">
            {{ s.therapistEmail || "N/A"
            }}<span *ngIf="i < affectedSessions.length - 1">, </span>
          </span>
        </li>
        <li>New therapist: {{ getSelectedTherapistName() }}</li>
      </ul>
    </div>

    <div
      *ngIf="transferConfirmedSessions && affectedSessions.length > 0"
      class="mt-4"
    >
      <label class="font-medium mb-1 block">Select Date</label>
      <nz-date-picker
        class="w-full"
        (ngModelChange)="onNewSessionDateChange($event)"
        [(ngModel)]="selectedSessionDate"
      ></nz-date-picker>
    </div>

    <div
      class="mt-4"
      *ngIf="
        transferConfirmedSessions &&
        affectedSessions.length > 0 &&
        selectedSessionDate &&
        checkBoxTimeRangeOptions.length === 0
      "
    >
      <p>No available slots for selected day.</p>
    </div>

    <div
      class="mt-4"
      *ngIf="
        transferConfirmedSessions &&
        affectedSessions.length > 0 &&
        checkBoxTimeRangeOptions.length > 0
      "
    >
      <label class="font-medium mb-2 block">Available Slots</label>
      <nz-checkbox-wrapper (nzOnChange)="onNewSessionTimeChange($event)">
        <div
          *ngFor="let status of checkBoxTimeRangeOptions; let i = index"
          class="mb-1"
        >
          <label
            nz-checkbox
            [nzDisabled]="status.disabled"
            [nzValue]="status.value"
            [(ngModel)]="status.checked"
            (ngModelChange)="onCheckboxClick($event, i)"
          >
            {{ status.label }}
          </label>
        </div>
      </nz-checkbox-wrapper>
    </div>
  </ng-container>
</nz-modal>
<nz-modal
  [(nzVisible)]="deactivePlanModalVisible"
  [nzTitle]="'Confirm Cancellation'"
  [nzFooter]="modalFooter"
  [nzContent]="modalContent"
  (nzOnCancel)="deactivePlanModalVisible = false"
>
  <ng-template #modalContent>
    <p>Are you sure you want to deactived the plan subscription?</p>
  </ng-template>
  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelDeactivePlan()">
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="handleOkDeactivePlan()">
      Confirm
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="blockPlanModalVisible"
  [nzTitle]="'Block Confirm Cancellation'"
  [nzFooter]="blockModalFooter"
  [nzContent]="blockModalContent"
  (nzOnCancel)="blockPlanModalVisible = false"
>
  <ng-template #blockModalContent>
    <p>Are you sure you want to deactivate the block plan subscription?</p>
    <label for="blockMessage"><strong>Block Message</strong></label>
    <textarea
      id="blockMessage"
      [(ngModel)]="blockMessage"
      nz-input
      rows="3"
      placeholder="Enter reason for block plan subscription"
      style="width: 100%; margin-top: 8px"
    ></textarea>
  </ng-template>

  <ng-template #blockModalFooter>
    <button nz-button nzType="default" (click)="handleCancelBlockPlan()">
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="handleOkBlockPlan()">
      Confirm
    </button>
  </ng-template>
</nz-modal>

<nz-modal
  [(nzVisible)]="blockMessageModalVisible"
  [nzTitle]="'Block Message'"
  [nzContent]="blockModalMessageContent"
  (nzOnCancel)="blockMessageModalVisible = false"
  [nzFooter]="null"
>
  <ng-template #blockModalMessageContent>
    <p>{{ blockMessageText }}</p>
  </ng-template>
</nz-modal>
<nz-modal
  [(nzVisible)]="isWarningModalVisible"
  [nzTitle]="'Warning'"
  [nzFooter]="warningModalFooter"
  [nzContent]="warningModalContent"
  (nzOnCancel)="isWarningModalVisible = false"
>
  <ng-template #warningModalContent>
    <p>
      If you continue without selecting "Also transfer confirmed sessions", only
      Open and Pending sessions will move to the new therapist. Confirmed
      sessions will remain with the current therapist and cannot be transferred
      later.
    </p>
  </ng-template>

  <ng-template #warningModalFooter>
    <button nz-button nzType="default" (click)="handleWarningModalBack()">
      Back
    </button>
    <button nz-button nzType="primary" (click)="handleWarningModalConfirm()">
      Confirm
    </button>
  </ng-template>
</nz-modal>
<app-send-feedback-document-modal
  [(visible)]="isVisibleSendFeedback"
  [sessions]="sendFeedbackSubscription?.sessionDetailslist || []"
  [therapistOptions]="sendFeedbackTherapistOptions"
  [defaultTherapistId]="sendFeedbackDefaultTherapistId"
></app-send-feedback-document-modal>
